// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPlaySquareOutlinedSvg from "@fishx/icons-svg/es/asn/PPlaySquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PPlaySquareOutlined = function PPlaySquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPlaySquareOutlinedSvg
  }));
};

PPlaySquareOutlined.displayName = 'PPlaySquareOutlined';
export default React.forwardRef(PPlaySquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPlaySquareOutlined.js
// module id = 3537
// module chunks = 0